/* eslint-disable @typescript-eslint/no-explicit-any -- The web component event types use 'any' and cannot be strongly typed */
// apps/managetrips/src/components/auth-wrapper/auth-wrapper-wc.tsx
"use client";

import type { Ref } from "react";
import { useEffect } from "react";
import Script from "next/script";
import type {
  AuthWrapperCustomEvent,
  WcAuthWrapperElement,
  AuthWrapperElementAttributes,
} from "@jb-manage-trips/types/web-components";

export type AuthWrapperWcProperties = AuthWrapperElementAttributes & {
  onActions: (event: AuthWrapperCustomEvent<any>) => void;
  onReady: () => void;
  onResources: (event: AuthWrapperCustomEvent<any>) => void;
  ref?: Ref<WcAuthWrapperElement>;
  scriptSource: string;
};
export const AuthWrapperWc = ({
  clientId,
  excludedRoutes,
  fullStoryOrgId,
  handleReturnUrl,
  idleTimerDuration,
  isProduction,
  issuer,
  logoutWhenIdle,
  onActions,
  onReady,
  onResources,
  redirectUri,
  ref,
  scriptSource,
}: AuthWrapperWcProperties) => {
  useEffect(() => {
    const handleActions: EventListener = (event) => {
      onActions(event as AuthWrapperCustomEvent<any>);
    };

    document.addEventListener("ACTIONS", handleActions);

    return () => {
      document.removeEventListener("ACTIONS", handleActions);
    };
  }, [onActions]);

  useEffect(() => {
    const handleReady: EventListener = () => {
      onReady();
    };

    document.addEventListener("READY", handleReady);

    return () => {
      document.removeEventListener("READY", handleReady);
    };
  }, [onReady]);

  useEffect(() => {
    const handleResources: EventListener = (event) => {
      onResources(event as AuthWrapperCustomEvent<any>);
    };

    document.addEventListener("RESOURCES", handleResources);

    return () => {
      document.removeEventListener("RESOURCES", handleResources);
    };
  }, [onResources]);

  return (
    <>
      {
        // @ts-expect-error - wc-auth-wrapper is a custom element not declared in JSX.IntrinsicElements
        <wc-auth-wrapper
          clientId={clientId}
          excludedRoutes={excludedRoutes}
          fullStoryOrgId={fullStoryOrgId}
          handleReturnUrl={handleReturnUrl}
          idleTimerDuration={idleTimerDuration}
          isProduction={isProduction}
          issuer={issuer}
          logoutWhenIdle={logoutWhenIdle}
          redirectUri={redirectUri}
          ref={ref}
        />
      }

      <Script id="auth-wrapper-script" onReady={onReady} src={scriptSource} />
    </>
  );
};

AuthWrapperWc.displayName = "AuthWrapperWc";

/* eslint-enable @typescript-eslint/no-explicit-any */
